import React from 'react';
import { pluralize } from 'lib/helpers';
import { getComparisonText } from './utils';

interface Props {
  procrastinationScore: number;
}

/** Slide 08 - Procrastination score */
export function Slide08({ procrastinationScore }: Props) {
  const text = getComparisonText(procrastinationScore);

  return (
    <div className="absolute inset-0 text-white h-full w-full text-justify font-light">
      <div className="absolute top-[20%] px-10">
        <div className="text-4xl leading-tight pb-8">
          It took you an average of
          {' '}
          <span className="font-extrabold">
            {text.days}
          </span>
          {' '}
          {pluralize('day', procrastinationScore)}
          {' '}
          to take credit for your work!
        </div>
        <div className="text-4xl text-justify">
          That is
          {' '}
          <span className="font-bold">{text.comparison}</span>
        </div>
        <div className="text-7xl font-extrabold leading-none animate-zoomin">
          {text.speed}
        </div>
        {text.showThanTheAverage && (
          <div className="text-4xl leading-tight">
            than the average Gondolier!
          </div>
        )}
      </div>
    </div>
  );
}
